import { faSquarePlus } from "@fortawesome/pro-solid-svg-icons"
import { Button, TextField } from "@mui/material"
import { translate } from "app/language/service"
import { REPORTS_EDIT_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import React from "react"
import { IReportParameters } from "reports/model"
import { createUserReport } from "reports/tools/common"
import { FlexBox } from "ui/components/FlexBox"
import { LinearLoader } from "ui/components/LinearLoader"
import { Popup } from "ui/components/Popup"

interface ICreateReportPopupProps {
  parameters: IReportParameters
  onClose: () => any
}

export const CreateReportPopup = React.memo(({ parameters, onClose }: ICreateReportPopupProps) => {
  const [isSaving, setIsSaving] = React.useState(false)
  const [name, setName] = React.useState("")
  const [description, setDescription] = React.useState("")
  const submit = async () => {
    if (!name) {
      return
    }
    if (!isSaving) {
      setIsSaving(true)
    }
    // createUserReport never throw
    const result = await createUserReport({
      ...parameters,
      name,
      description
    })
    setIsSaving(false)
    if (result) {
      navigate({
        path: REPORTS_EDIT_PATH,
        pathParams: result.id
      })
    }
  }
  const onKeyUp = (event: React.KeyboardEvent<HTMLDivElement>) => {
    event.stopPropagation()
    event.preventDefault()
    if (event.key === "Enter") {
      submit()
    }
  }
  return (
    <Popup
      icon={faSquarePlus}
      id="reports-create-popup"
      displayCloseIcon={!isSaving}
      title={translate("reports.add.title")}
      onClose={() => {
        if (isSaving) {
          return
        }
        onClose()
      }}>
      <FlexBox vertical fullWidth gap sx={{ p: "1rem" }}>
        {isSaving ? (
          <LinearLoader text={translate("reports.saving")} />
        ) : (
          <>
            <TextField
              id="reports-create-form-name"
              label={translate("label.name")}
              value={name}
              size="small"
              required
              onKeyUp={event => onKeyUp(event)}
              onChange={event => setName(event.target.value)}
              sx={{ width: "20rem" }}
            />
            <TextField
              id="reports-create-form-description"
              label={translate("label.description")}
              value={description}
              multiline
              rows={3}
              size="small"
              onKeyUp={event => onKeyUp(event)}
              onChange={event => setDescription(event.target.value)}
              sx={{ width: "20rem" }}
            />
          </>
        )}
        <FlexBox gap jc="end" fullWidth>
          <Button id="reports-create-form-cancel" variant="outlined" disabled={isSaving} onClick={() => onClose()}>
            {translate("button.cancel")}
          </Button>
          <Button
            id="reports-create-form-save"
            variant="contained"
            disabled={!name || isSaving}
            onClick={() => submit()}>
            {translate("button.save")}
          </Button>
        </FlexBox>
      </FlexBox>
    </Popup>
  )
})
